// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import {useUserInputAsTextFieldWithInitialValue} from '@tectonics/prs/user-input-values';
import { useUserInputValidationError, type UserInputValidationError } from '@tectonics/prs/validation';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';

import {InputDate} from '@tectonics/look-and-feel/volcanes/atoms/input-date';
import styled from 'styled-components';
import {ErrorLabel} from '@tectonics/look-and-feel/volcanes/molecules/error-label';
import {translate} from '@tectonics/translate';

export function FieldCustomerBirthdate(): Node {
  const inputId = useUniqueId();
  const submitting = useSubmitting();

  const [, handleChangeBirthdate] = useUserInputAsTextFieldWithInitialValue('customerBirthdate', '');

  const formHasBeenSent = useFormHasBeenSent();
  const validationError = useUserInputValidationError('customerBirthdate');

  return (
    <Wrapper data-test-name={'customer-birthdate'}>
      <label htmlFor={inputId}>
        {translate('volcanes.opened-payment.customer.form.fieldCustomerBirthdate.label')}
      </label>
      <InputDate
        id={inputId}
        onChange={handleChangeBirthdate}
        fashion={formHasBeenSent && validationError ? 'error' : null}
        readOnly={submitting}
        data-error={formHasBeenSent && validationError ? 'error' : null}
        name={'customerBirthdate'}
      />


      {formHasBeenSent && validationError && (
        <ValidationMessage validationError={validationError} />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

type ValidationMessageProps = {|
  validationError: UserInputValidationError,
|};

function ValidationMessage({ validationError }: ValidationMessageProps): Node {
  switch (validationError.id) {
    case 'empty':
      return (
        <ErrorLabel>
          {translate('volcanes.opened-payment.customer.form.fieldCustomerBirthdate.validationMessage.empty')}
        </ErrorLabel>
      );

    case 'server-error':
      return (
        <ErrorLabel>
          {translate('volcanes.opened-payment.customer.form.fieldCustomerBirthdate.validationMessage.serverError')}
        </ErrorLabel>
      );

    default:
      return (
        <ErrorLabel>
          {translate('volcanes.opened-payment.customer.form.fieldCustomerBirthdate.validationMessage.invalid')}
        </ErrorLabel>
      );
  }

}
